module.exports = __webpack_public_path__ + "static/logo-664d61b48de67d08b9c7f49cb80e5edf.png";